<div class="visible-lg">
  <div class="flex-container row">
    <div class="bmw-bulletin-container flex-60">
      <div class="bmw-bulletin-title">
        {{getPageTitle()}}
      </div>
      <form #formaddscopepattern="ngForm" (ngSubmit)="onSubmit(formaddscopepattern)">
        <div *ngIf='bulletinType === "scope pattern library" && actionType === "add"'>
          <div class="flex-container row">
            <div class="flex-25">
              <ng-container
                *ngIf="( (makeSelectedField.touched || formaddscopepattern.submitted) && makeSelectedField.errors?.defaultSelected); then mandatoryMake; else optionalMake">
              </ng-container>
              <ng-template #mandatoryMake>
                <div>
                  <label class="text-danger">Make*</label>
                </div>
              </ng-template>
              <ng-template #optionalMake>
                <div>
                  <label>Make*</label>
                </div>
              </ng-template>
              <!-- <em
              *ngIf="formaddscopepattern.controls.makeSelected?.invalid && (formaddscopepattern.controls.makeSelected?.touched || mouseoverLogin)">Required</em> -->
              <div class="bmw-cms-new-bulletin-select">
                <select class="form-control" appSelectValidator="undefined" #makeSelectedField id="makeSelected"
                  name="makeSelected" [ngModel]="makeSelected"
                  (ngModelChange)="makeSelectedField.value = onMakeSelectionChanged($event)" style="width:80%;"
                  [class.field-error]="formaddscopepattern.submitted && makeSelectedField.invalid">
                  <option ngValue="undefined" disabled selected> Select</option>
                  <option value="BMW">BMW</option>
                  <option value="MINI">MINI</option>
                </select>
                <!-- <div [hidden]="!formaddscopepattern.submitted || makeSelectedField.valid" class="alert alert-danger">
                Select Make
              </div> -->
              </div>
            </div>
            <div class="flex-25">
              <ng-container
                *ngIf="( formaddscopepattern.submitted && scopepatternnumberField.errors?.required && inputMake!==null); then mandatoryCatalogNumber; else optionalCatalogNumber">
              </ng-container>
              <ng-template #mandatoryCatalogNumber>
                <div>
                  <label class="text-danger">SPL Number*</label>
                </div>
              </ng-template>
              <ng-template #optionalCatalogNumber>
                <div>
                  <label>SPL Number*</label>
                </div>
              </ng-template>
              <input id="scopepatternnumber" name="scopepatternnumber" class="form-control" [(ngModel)]='documentNumber'
                type="text" minlength="8" maxlength="8" placeholder="00 00 00" required
                #scopepatternnumberField="ngModel" required (keyup)="formatBulletinNumber($event, 'scope pattern')"
                [class.field-error]="formaddscopepattern.submitted && scopepatternnumberField.invalid">
              <!-- <div [hidden]="!formaddscopepattern.submitted || scopepatternnumberField.valid" class="alert alert-danger">
                  Enter valid Noise Catalog Number.
              </div> -->
              <span *ngIf="scopepatternnumberField.touched && scopepatternnumberField.errors?.minlength">
                <small style="color: red">Min. length 6 characters</small>
              </span>
              <!-- <div
              *ngIf="scopepatternnumberField.invalid && (scopepatternnumberField.dirty || scopepatternnumberField.touched)"
              class="alert alert-danger">
              <div *ngIf="scopepatternnumberField.errors.required">
                Noise Catalog Number is required.
              </div>
              <div *ngIf="scopepatternnumberField.errors.minlength">
                Noise Catalog Number must be at least 6 characters long.
              </div>
            </div> -->
            </div>
            <div class="flex-25">
              <ng-container
                *ngIf="( ( formaddscopepattern.submitted) && mydateField.errors?.required && inputMake!==null); then mandatoryDate; else optionalDate">
              </ng-container>
              <ng-template #mandatoryDate>
                <div>
                  <label class="text-danger">Date*</label>
                </div>
              </ng-template>
              <ng-template #optionalDate>
                <div>
                  <label>Date*</label>
                </div>
              </ng-template>
              <div >
                <input type="date" name="mydate" id="mydate" [(ngModel)]="inputDate" class="form-control" required/>
                <!-- <span class="text-danger" *ngIf="( formaddscopepattern.submitted) && mydateField.errors?.required">
                  *Required
                </span> -->
              </div>
            </div>
          </div>
          <div class="flex-container row">            
          </div>
          <!-- <div flex fxLayout="row" style="margin-top: 10px; margin-bottom:7px" *ngIf='relatedSIBs?.length > 0'>
          </div> -->
          <div class="flex-container row">
            <div class="flex-87">
              <ng-container
                *ngIf="( formaddscopepattern.submitted && scopePatternTitleField.errors?.required &&  inputMake!==null); then mandatoryScopePatternTitle; else optionalScopePatternTitle">
              </ng-container>
              <ng-template #mandatoryScopePatternTitle>
                <div>
                  <label class="text-danger">Title*</label>
                </div>
              </ng-template>
              <ng-template #optionalScopePatternTitle>
                <div>
                  <label>Title*</label>
                </div>
              </ng-template>
              <div>
                <!-- <em
                  *ngIf="formaddscopepattern.controls.scopePatternTitle?.invalid && (formaddscopepattern.controls.scopePatternTitle?.touched || mouseoverLogin)">Required</em> -->
                <input type="text" id="scopePatternTitle" name="scopePatternTitle" #scopePatternTitleField="ngModel"
                  required [(ngModel)]="textareaContent">
                <!-- <span class="text-danger"
                  *ngIf="( formaddscopepattern.submitted) && scopePatternTitleField.errors?.required">
                  *Required
                </span> -->
              </div>
              <!-- <div [hidden]="!formaddscopepattern.submitted || scopePatternTitle.valid" class="alert alert-danger">
                Enter Noise Catalog Title.
              </div> -->
            </div>
          </div>
          <div class="flex-container row" style="margin-top: 20px">
            <div class="flex-70">
              <label>E Series*</label><br />
              <ng-multiselect-dropdown #multiSelectSeries id="multiSelectSeries" name="multiSelectSeries"
                [placeholder]="'Select'" [data]="dropdownESeriesList" [(ngModel)]="seriesFilterList"
                [settings]="dropdownSettingsSeries" [disabled]="false" (onSelect)='addToNoiseSelection("series",$event)'
                (onDeSelect)='removeFromNoiseSelection("series",$event)'>
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="flex-container row">
            <div>
              <div class="bmw-bulletin-series-chips" *ngFor='let series of seriesFilterList'>
                {{ series.seriesName }}
                <!-- <i class="material-icons" (click)='removeFromSelection("series", series)'>close</i> -->
              </div>
            </div>
          </div>

          <div class="flex-container row" style="margin-top: 20px">
            <div class="flex-70">
              <label>Signal Name*</label><br />
              <ng-multiselect-dropdown #multiSelectArea id="multiSelectArea" name="multiSelectArea"
                [placeholder]="'Select'" [data]="dropdownAreaList" [(ngModel)]="areaFilterList"
                [settings]="dropdownSettingsArea" (onSelect)='addToNoiseSelection("area",$event)'
                (onDeSelect)='removeFromNoiseSelection("area",$event)'>
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="flex-container row">
            <div>
              <div class="bmw-bulletin-series-chips" *ngFor='let area of areaFilterList'>
                {{ area.signalName }}
                <!-- <i class="material-icons" (click)='removeFromSelection("area", area)'>close</i> -->
              </div>
            </div>
          </div>              
         
          
          <!-- Uncoment here for file upload -->
          <div class="bmw-cms-modal-button new-bulletin">
            <div class="upload-btn-wrapper flex-150-px">
              <button class="btn pointer">Choose File*</button>
              <input type="file" name="myfile" (change)='fileUpload($event)' />
            </div>
            <div class="bmw-bulletin-nofile-label">{{uploadedFileName}}</div>
          </div> 

          <div class="flex-container row">
            <div class="bmw-cms-modal-button new-bulletin">
              <!-- <button [disabled]='!inputMake' class="bmw-button-secondary" (click)='submit()'>Submit</button> -->

              <span *ngIf="errorMessage!==''"><small style="color: red;text-align: left;">
                  <p text-align: left>&nbsp;&nbsp;{{ errorMessage }}</p>
                </small></span>
              <span
                *ngIf="formaddscopepattern.touched && formaddscopepattern.invalid && inputMake!==null && formaddscopepattern.submitted"><small
                  style="color: red;text-align: left;">
                  <p text-align: left>Please enter all mandatory fields.</p>
                </small></span>
              <button class="bmw-button-secondary" type="submit">Submit</button>

              <!-- <span ><small style="color: red">{{formaddscopepattern.pristine}}</small></span>
              <span ><small style="color: red">{{formaddscopepattern.touched}}</small></span>
              <span ><small style="color: red">{{formaddscopepattern.dirty}}</small></span> -->
            </div>
          </div>
          <!-- <div flex fxLayout="row"> -->
          <!-- <div class="bmw-cms-modal-button new-bulletin" (mouseenter)="mouseoverLogin=true"
              (mouseleave)="mouseoverLogin=false">
              <button (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false"
                [disabled]='formaddscopepattern.invalid' class="bmw-button-secondary">Submit</button>
            </div> -->
          <!-- <div class="bmw-cms-modal-button new-bulletin">
              <span (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false">
                <button mat-raised-button (mouseenter)="mouseoverLogin=true" (mouseleave)="mouseoverLogin=false"
                  color="primary" class="btn btn-primary search-btn"
                  [disabled]="formaddscopepattern.invalid">Submit</button>
              </span>
            </div> -->
          <!-- </div> -->

        </div>
        <!-- <pre>{{formaddscopepattern.value | json}}</pre>
        <pre>{{inputMake | json}}</pre> -->
      </form>

    </div>
  </div>
</div>